import { render, staticRenderFns } from "./RegisterValidate.vue?vue&type=template&id=7bb88855"
import script from "./RegisterValidate.vue?vue&type=script&lang=js"
export * from "./RegisterValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports